import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  SignedIntFormatterStructureuogj4y4pj858 as SignedIntFormatterStructure,
  UnsignedIntFormatterStructure2iqfxgv3d2ejy as UnsignedIntFormatterStructure,
  StringFormatterStructure3i97mc47fm0qc as StringFormatterStructure,
  DecimalFractionFormatterStructure2fby7dmyhkzn1 as DecimalFractionFormatterStructure,
} from './formatter/FormatterOperation.mjs';
import { SpacePaddedFormatter1bbtqhbgrvf8v as SpacePaddedFormatter } from './formatter/Formatter.mjs';
import {
  SignedIntParsergn6823y2nf4q as SignedIntParser,
  spaceAndZeroPaddedUnsignedInt3iec50j4qusnr as spaceAndZeroPaddedUnsignedInt,
  StringSetParserOperation82b6pl2fn98q as StringSetParserOperation,
  NumberSpanParserOperation3qyp02c4km7yu as NumberSpanParserOperation,
} from './parser/ParserOperation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ParserStructure2cqp7gjft5io4 as ParserStructure } from './parser/Parser.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { FractionPartConsumerf0mxqojimz2s as FractionPartConsumer } from './parser/NumberConsumer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Accessor$getterNotNull$ref(p0) {
  var l = (_this__u8e3s4) => p0.g20(_this__u8e3s4);
  l.callableName = 'getterNotNull';
  return l;
}
var SignedIntFieldFormatDirectiveClass;
function SignedIntFieldFormatDirective() {
  if (SignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
        this.e1v_1 = field;
        this.f1v_1 = minDigits;
        this.g1v_1 = maxDigits;
        this.h1v_1 = spacePadding;
        this.i1v_1 = outputPlusOnExceededWidth;
        // Inline function 'kotlin.require' call
        if (!(this.f1v_1 == null || this.f1v_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.f1v_1 + ') is negative';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.g1v_1 == null || this.f1v_1 == null || this.g1v_1 >= this.f1v_1)) {
          var message_0 = 'The maximum number of digits (' + this.g1v_1 + ') is less than the minimum number of digits (' + this.f1v_1 + ')';
          throw IllegalArgumentException().a1(toString(message_0));
        }
      }
      j1v() {
        return this.e1v_1;
      }
      y1t() {
        var tmp = Accessor$getterNotNull$ref(this.e1v_1.h20());
        var tmp0_elvis_lhs = this.f1v_1;
        var formatter = new (SignedIntFormatterStructure())(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.i1v_1);
        return !(this.h1v_1 == null) ? new (SpacePaddedFormatter())(formatter, this.h1v_1) : formatter;
      }
      a1u() {
        return SignedIntParser(this.f1v_1, this.g1v_1, this.h1v_1, this.e1v_1.h20(), this.e1v_1.i20(), this.i1v_1);
      }
    }
    initMetadataForClass($, 'SignedIntFieldFormatDirective');
    SignedIntFieldFormatDirectiveClass = $;
  }
  return SignedIntFieldFormatDirectiveClass;
}
function Accessor$getterNotNull$ref_0(p0) {
  var l = (_this__u8e3s4) => p0.g20(_this__u8e3s4);
  l.callableName = 'getterNotNull';
  return l;
}
var UnsignedIntFieldFormatDirectiveClass;
function UnsignedIntFieldFormatDirective() {
  if (UnsignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, spacePadding) {
        this.p1v_1 = field;
        this.q1v_1 = minDigits;
        this.r1v_1 = spacePadding;
        this.s1v_1 = this.p1v_1.p20_1;
        // Inline function 'kotlin.require' call
        if (!(this.q1v_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.q1v_1 + ') is negative';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.s1v_1 >= this.q1v_1)) {
          var message_0 = 'The maximum number of digits (' + this.s1v_1 + ') is less than the minimum number of digits (' + this.q1v_1 + ')';
          throw IllegalArgumentException().a1(toString(message_0));
        }
        if (!(this.r1v_1 == null)) {
          // Inline function 'kotlin.require' call
          if (!(this.r1v_1 > this.q1v_1)) {
            var message_1 = 'The space padding (' + this.r1v_1 + ') should be more than the minimum number of digits (' + this.q1v_1 + ')';
            throw IllegalArgumentException().a1(toString(message_1));
          }
        }
      }
      j1v() {
        return this.p1v_1;
      }
      y1t() {
        var formatter = new (UnsignedIntFormatterStructure())(Accessor$getterNotNull$ref_0(this.p1v_1.j20_1), this.q1v_1);
        return !(this.r1v_1 == null) ? new (SpacePaddedFormatter())(formatter, this.r1v_1) : formatter;
      }
      a1u() {
        return spaceAndZeroPaddedUnsignedInt(this.q1v_1, this.s1v_1, this.r1v_1, this.p1v_1.j20_1, this.p1v_1.m20_1);
      }
    }
    initMetadataForClass($, 'UnsignedIntFieldFormatDirective');
    UnsignedIntFieldFormatDirectiveClass = $;
  }
  return UnsignedIntFieldFormatDirectiveClass;
}
function getStringValue($this, target) {
  // Inline function 'kotlin.let' call
  var it = $this.x1v_1.j20_1.g20(target);
  var tmp0_elvis_lhs = getOrNull($this.y1v_1, it - $this.x1v_1.k20_1 | 0);
  return tmp0_elvis_lhs == null ? 'The value ' + it + ' of ' + $this.x1v_1.m20_1 + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
}
var AssignableStringClass;
function AssignableString() {
  if (AssignableStringClass === VOID) {
    class $ {
      constructor($outer) {
        this.q20_1 = $outer;
      }
      r20(container, newValue) {
        var tmp0_safe_receiver = this.q20_1.x1v_1.j20_1.s20(container, this.q20_1.y1v_1.s1(newValue) + this.q20_1.x1v_1.k20_1 | 0);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.q20_1.y1v_1.q1(tmp0_safe_receiver - this.q20_1.x1v_1.k20_1 | 0);
        }
        return tmp;
      }
      s20(container, newValue) {
        var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
        return this.r20(tmp, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
      }
      i20() {
        return this.q20_1.z1v_1;
      }
    }
    initMetadataForClass($, 'AssignableString');
    AssignableStringClass = $;
  }
  return AssignableStringClass;
}
function NamedUnsignedIntFieldFormatDirective$getStringValue$ref(p0) {
  var l = (_this__u8e3s4) => {
    var tmp0 = p0;
    return getStringValue(tmp0, _this__u8e3s4);
  };
  l.callableName = 'getStringValue';
  return l;
}
var NamedUnsignedIntFieldFormatDirectiveClass;
function NamedUnsignedIntFieldFormatDirective() {
  if (NamedUnsignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, values, name) {
        this.x1v_1 = field;
        this.y1v_1 = values;
        this.z1v_1 = name;
        // Inline function 'kotlin.require' call
        if (!(this.y1v_1.p1() === ((this.x1v_1.l20_1 - this.x1v_1.k20_1 | 0) + 1 | 0))) {
          var message = 'The number of values (' + this.y1v_1.p1() + ') in ' + toString(this.y1v_1) + ' does not match the range of the field (' + ((this.x1v_1.l20_1 - this.x1v_1.k20_1 | 0) + 1 | 0) + ')';
          throw IllegalArgumentException().a1(toString(message));
        }
      }
      j1v() {
        return this.x1v_1;
      }
      y1t() {
        return new (StringFormatterStructure())(NamedUnsignedIntFieldFormatDirective$getStringValue$ref(this));
      }
      a1u() {
        return new (ParserStructure())(listOf(new (StringSetParserOperation())(this.y1v_1, new (AssignableString())(this), 'one of ' + toString(this.y1v_1) + ' for ' + this.z1v_1)), emptyList());
      }
    }
    initMetadataForClass($, 'NamedUnsignedIntFieldFormatDirective');
    NamedUnsignedIntFieldFormatDirectiveClass = $;
  }
  return NamedUnsignedIntFieldFormatDirectiveClass;
}
function getStringValue_0($this, target) {
  // Inline function 'kotlin.let' call
  var it = $this.e1y_1.h20().g20(target);
  var tmp0_elvis_lhs = $this.f1y_1.p3($this.e1y_1.h20().g20(target));
  return tmp0_elvis_lhs == null ? 'The value ' + toString_0(it) + ' of ' + $this.e1y_1.i20() + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
}
var AssignableStringClass_0;
function AssignableString_0() {
  if (AssignableStringClass_0 === VOID) {
    class $ {
      constructor($outer) {
        this.t20_1 = $outer;
      }
      r20(container, newValue) {
        var tmp0_safe_receiver = this.t20_1.e1y_1.h20().s20(container, ensureNotNull(this.t20_1.h1y_1.p3(newValue)));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.t20_1.f1y_1.p3(tmp0_safe_receiver);
        }
        return tmp;
      }
      s20(container, newValue) {
        var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
        return this.r20(tmp, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
      }
      i20() {
        return this.t20_1.g1y_1;
      }
    }
    initMetadataForClass($, 'AssignableString');
    AssignableStringClass_0 = $;
  }
  return AssignableStringClass_0;
}
function NamedEnumIntFieldFormatDirective$getStringValue$ref(p0) {
  var l = (_this__u8e3s4) => {
    var tmp0 = p0;
    return getStringValue_0(tmp0, _this__u8e3s4);
  };
  l.callableName = 'getStringValue';
  return l;
}
var NamedEnumIntFieldFormatDirectiveClass;
function NamedEnumIntFieldFormatDirective() {
  if (NamedEnumIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, mapping, name) {
        this.e1y_1 = field;
        this.f1y_1 = mapping;
        this.g1y_1 = name;
        var tmp = this;
        // Inline function 'kotlin.collections.associate' call
        var this_0 = this.f1y_1.d2();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(element.f2(), element.e2());
          destination.s3(pair.af_1, pair.bf_1);
        }
        tmp.h1y_1 = destination;
      }
      j1v() {
        return this.e1y_1;
      }
      y1t() {
        return new (StringFormatterStructure())(NamedEnumIntFieldFormatDirective$getStringValue$ref(this));
      }
      a1u() {
        return new (ParserStructure())(listOf(new (StringSetParserOperation())(this.f1y_1.r3(), new (AssignableString_0())(this), 'one of ' + toString(this.f1y_1.r3()) + ' for ' + this.g1y_1)), emptyList());
      }
    }
    initMetadataForClass($, 'NamedEnumIntFieldFormatDirective');
    NamedEnumIntFieldFormatDirectiveClass = $;
  }
  return NamedEnumIntFieldFormatDirectiveClass;
}
function Accessor$getterNotNull$ref_1(p0) {
  var l = (_this__u8e3s4) => p0.g20(_this__u8e3s4);
  l.callableName = 'getterNotNull';
  return l;
}
var DecimalFractionFieldFormatDirectiveClass;
function DecimalFractionFieldFormatDirective() {
  if (DecimalFractionFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, maxDigits, zerosToAdd) {
        this.a1z_1 = field;
        this.b1z_1 = minDigits;
        this.c1z_1 = maxDigits;
        this.d1z_1 = zerosToAdd;
      }
      j1v() {
        return this.a1z_1;
      }
      y1t() {
        return new (DecimalFractionFormatterStructure())(Accessor$getterNotNull$ref_1(this.a1z_1.h20()), this.b1z_1, this.c1z_1, this.d1z_1);
      }
      a1u() {
        return new (ParserStructure())(listOf(new (NumberSpanParserOperation())(listOf(new (FractionPartConsumer())(this.b1z_1, this.c1z_1, this.a1z_1.h20(), this.a1z_1.i20())))), emptyList());
      }
    }
    initMetadataForClass($, 'DecimalFractionFieldFormatDirective');
    DecimalFractionFieldFormatDirectiveClass = $;
  }
  return DecimalFractionFieldFormatDirectiveClass;
}
//region block: exports
export {
  DecimalFractionFieldFormatDirective as DecimalFractionFieldFormatDirective1h9sbm886izzq,
  NamedEnumIntFieldFormatDirective as NamedEnumIntFieldFormatDirective2e2bgf4uj6a33,
  NamedUnsignedIntFieldFormatDirective as NamedUnsignedIntFieldFormatDirective1yq6ki9eqgm4v,
  SignedIntFieldFormatDirective as SignedIntFieldFormatDirective2ce7tjucbhgd2,
  UnsignedIntFieldFormatDirective as UnsignedIntFieldFormatDirective20kfpdbszyixg,
};
//endregion

//# sourceMappingURL=FieldFormatDirective.mjs.map
